import { render, staticRenderFns } from "./car-complectation2.vue?vue&type=template&id=56a1e5c1&"
import script from "./car-complectation2.vue?vue&type=script&lang=js&"
export * from "./car-complectation2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports